module.exports = __webpack_public_path__ + "img/students-meeting.aac00a74.jpg";